import { render, staticRenderFns } from "./workshopinfo.vue?vue&type=template&id=2a8b3e7a"
import script from "./workshopinfo.vue?vue&type=script&lang=ts"
export * from "./workshopinfo.vue?vue&type=script&lang=ts"
import style0 from "./workshopinfo.vue?vue&type=style&index=0&id=2a8b3e7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports